"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const R = __importStar(require("ramda"));
const omitDeep = (omitedProps, objectForOmitting) => {
    if (!objectForOmitting ||
        !R.is(Object, objectForOmitting) ||
        typeof objectForOmitting === 'number' ||
        typeof objectForOmitting === 'string') {
        return objectForOmitting;
    }
    const currentLevelOmitedObject = Array.isArray(objectForOmitting)
        ? R.map(value => omitDeep(omitedProps, value), objectForOmitting)
        : R.omit(omitedProps, objectForOmitting);
    const omitValue = (value) => {
        if (R.is(Array, value)) {
            return value.map((item) => omitDeep(omitedProps, item));
        }
        else if (R.is(Object, value)) {
            return omitDeep(omitedProps, value);
        }
        return value;
    };
    const fullOmitedObject = Array.isArray(currentLevelOmitedObject)
        ? R.map(omitValue, currentLevelOmitedObject)
        : R.mapObjIndexed(omitValue, currentLevelOmitedObject);
    return fullOmitedObject;
};
exports.omitDeep = omitDeep;
//# sourceMappingURL=omitDeep.js.map